import './InAppPurchaseHistory.scss';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  inAppPurchaseHistorySelector,
  invoicePendingSelector,
} from 'redux/slices/team/selectors';
import { Table } from 'antd';
import moment from 'moment';

const statusToColor = {
  paid: '#d6ecff',
  uncollectible: '#fee3c0',
  void: '#e6e6fc',
  open: '#cbf4c9',
  draft: '#e3e8ee',
  deleted: '#fbb5b2',
};

const columns = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    render: (timestamp) => (
      <a>{moment.unix(+timestamp).format('MM/DD/YYYY hh:mm a')}</a>
    ),
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    render: (amount: number) => <div>{`$ ${+amount.toFixed(2)}`}</div>,
  },
  {
    title: 'Reason',
    dataIndex: 'reason',
    key: 'reason',
    // render: (amount: number) => <div>{`$ ${+amount.toFixed(2)}`}</div>,
  },
  {
    title: 'Status',
    key: 'status',
    dataIndex: 'status',
    render: (status) => (
      <div
        className="status"
        style={{ backgroundColor: statusToColor[status] }}
      >
        {status}
      </div>
    ),
  },
];
export const InAppPurchaseHistory = ({ teamId }) => {
  const dispatch = useDispatch();

  const invoices = useSelector(inAppPurchaseHistorySelector);
  const loading = useSelector(invoicePendingSelector);

  const dataSource = (invoices ?? []).map(
    ({ id, amount, date, status, reason }) => {
      return { key: date, amount, date, status, reason };
    }
  );

  return (
    <div className="in-app-purchases-table">
      <Table
        loading={loading}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
      />
    </div>
  );
};
